'use strict';

/**
 * UI Admin — étiquette Boxtal (B2.4b2).
 */

export function canShowExpeditionLabelActions(commande) {
  if (!commande || commande.modeRetrait !== 'expedition') return false;
  const shipment = commande.shipment;
  if (!shipment?.id) return false;
  if (String(shipment.provider || '').toUpperCase() !== 'BOXTAL') return false;
  if (!shipment.providerShipmentId) return false;
  return true;
}

export function expeditionLabelStatusMessage({ labelStatus, format, polling } = {}) {
  if (labelStatus === 'available') {
    return format ? `Étiquette disponible (${format})` : 'Étiquette disponible';
  }
  if (labelStatus === 'pending') {
    if (polling) {
      return 'Étiquette en cours de génération…';
    }
    return 'Étiquette en cours de génération';
  }
  return null;
}
